export default "__VITE_ASSET__CKusQoQ1__"